// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"9b027136","257":"88c8935d","335":"3477d0c8","542":"1ad8bde5"}[chunkId] + ".chunk.js";
};